import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Entry } from 'contentful';
import { RegisterPage } from 'src/app/model/page/group/user/register-page';
import { UserAccount } from 'src/app/model/page/group/user/user-account-request';
import { ApiService } from 'src/app/service/api.service';
import { entraAuthService } from 'src/app/service/auth.service';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ConfigService } from 'src/app/service/config.service';
import { PageLoaderService } from 'src/app/service/page-loader.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-register-page',
  templateUrl: './register-page.component.html',
  styleUrls: ['./register-page.component.scss']
})
export class RegisterPageComponent implements OnInit {
  registerPage: RegisterPage = {} as RegisterPage;
  userAccountRequest: UserAccount = {} as UserAccount;
  submitted = false;
  showPassword = false;
  showConfirmPassword = false;
  registrationSuccess = false;
  selectedAgentType = '';
  agentObj = {};
  registrationError = '';
  private readonly agentValidators: Record<string, { field: string; validators: ValidatorFn[] }> = {
    IATA: { field: 'IATAid', validators: [Validators.required, Validators.minLength(7), Validators.maxLength(10), Validators.pattern(/\-?\d*\.?\d{1,2}/)] },
    AGGREGATOR: { field: 'AggregatorId', validators: [Validators.required, Validators.minLength(7), Validators.maxLength(8), Validators.pattern(/\-?\d*\.?\d{1,2}/)] },
    CORPORATE: { field: 'CorporateId', validators: [Validators.required, Validators.minLength(7), Validators.maxLength(10)] },
    TIDS: { field: 'TIDSId', validators: [Validators.required, Validators.minLength(7), Validators.maxLength(8)] }
  };
  registerForm: FormGroup = new FormGroup({
    companyName: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(100)]),
    agentType: new FormControl('IATA', [Validators.required]),
    IATAid: new FormControl('', [Validators.required, Validators.minLength(7), Validators.maxLength(10), Validators.pattern(/\-?\d*\.?\d{1,2}/)]),
    AggregatorId: new FormControl(''),
    TIDSId: new FormControl(''),
    CorporateId: new FormControl(''),
    firstName: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(30)]),
    lastName: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(30)]),
    NDCCommercialNews: new FormControl(false),
    IAGPortalUsers: new FormControl(false),
    platformUpdates: new FormControl(false),
    operationalOldAPIUpdates: new FormControl(false),
    operationalNewAPIUpdates: new FormControl(false)
  });
  constructor(private contentfulService: ContentfulService, private router: Router, public entraAuthService: entraAuthService, public apiService: ApiService, private pageLoaderService: PageLoaderService, private configService: ConfigService) {}

  async ngOnInit(): Promise<void> {
    const query = { 'fields.title': 'Register' };
    this.contentfulService.getPageContentWithEntries(query).then((registerPageEntries) => {
      this.mapBanner(registerPageEntries);
    });
  }

  private mapBanner(registerPageEntries: Entry<any>[]) {
    registerPageEntries &&
      registerPageEntries
        .filter((entry) => ModelValidator.isBanner(entry))
        .forEach((entry) => {
          this.mapEntryToBanner(entry);
        });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.registerPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
      video: videoDetails?.fields?.file?.url  as string
    };
  }

  get f(): { [key: string]: AbstractControl } {
    return this.registerForm.controls;
  }

  async updateUserProfile() {
    this.submitted = true;

    if (this.registerForm.invalid) {
      return;
    } else {
      this.pageLoaderService.addPageLoader(true);

      let user_info = localStorage.getItem('user_info');
      let userData;
      if(user_info){
        userData=JSON.parse(user_info);
      }
      if (!userData) {
        this.pageLoaderService.addPageLoader(false);
        return;
      }
      this.userAccountRequest = {
          userRole: 'SITE_USER',
          agentType: this.registerForm.value.agentType,
          companyName: this.registerForm.value.companyName,
          identity: {
            firstName: this.registerForm.value.firstName,
            lastName: this.registerForm.value.lastName,
            email: userData.userEmail,
            mobileNumber: userData.mobileNumber
          },
          emailPreference: {
            commercialNews: this.registerForm.value.NDCCommercialNews ? 'Yes' : 'No',
            iagPortals: this.registerForm.value.IAGPortalUsers ? 'Yes' : 'No',
            platformUpdates: this.registerForm.value.platformUpdates ? 'Yes' : 'No',
            operationalNewAPIUpdates: this.registerForm.value.operationalNewAPIUpdates ? 'Yes' : 'No',
            operationalOldAPIUpdates: this.registerForm.value.operationalOldAPIUpdates ? 'Yes' : 'No'
          }
        };
        switch (this.registerForm.value.agentType) {
          case 'IATA':
            this.userAccountRequest.iataId = this.registerForm.value.IATAid;
            break;
          case 'AGGREGATOR':
            this.userAccountRequest.aggregatorId = this.registerForm.value.AggregatorId;
            break;
          case 'CORPORATE':
            this.userAccountRequest.corporateId = this.registerForm.value.CorporateId;
            break;
          case 'TIDS':
            this.userAccountRequest.tidsId = this.registerForm.value.TIDSId;
            break;
      }
      const apiResponse = await this.APICall(userData.userID || userData.userId);

        if (apiResponse.error) {
          if (apiResponse.error.error) {
            this.registrationError = apiResponse.error.error;
          }
          this.pageLoaderService.addPageLoader(false);
          if (apiResponse.error.status == 401) {
            localStorage.setItem('redirect_url', '/account/register');
            this.entraAuthService.initLogin();
          }
        } else {
          localStorage.setItem('siteUser', 'true');
          this.pageLoaderService.addPageLoader(false);
          const preferredUserName = userData.preferredUserName || userData.preferred_username || this.registerForm.value.firstName;
          localStorage.setItem('preferred_userName', preferredUserName);
          this.router.navigate(['/account/user-register-thank-you']);
        }
    }
  }

  async APICall(userId: string) {
    const queryParams = new HttpParams()
      .append('id', userId)
    return await this.apiService.sendPostRequestWithParams(this.userAccountRequest, '/user', queryParams);
  }

  onTextInput(event: any, controlName: string): void {
    const value = event?.detail?.value ?? '';
    this.registerForm.get(controlName)?.setValue(value);
  }

  onCheckboxChange(event: any, controlName: string): void {
    const checked = event?.detail?.checked ?? false;
    this.registerForm.get(controlName)?.setValue(checked);
  }

  // Only Integer Numbers
  keyPressNumbers(event: any) {
    var charCode = event.which ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
  signIn() {
    this.entraAuthService.initLogin();
  }

  onSelectAgent(event: { detail?: { value?: string } }): void {
    const value: string = event?.detail?.value ?? '';
    this.registerForm.get('agentType')?.setValue(value);
    Object.values(this.agentValidators).forEach(({ field }) => {
      const control = this.registerForm.get(field);
      control?.clearValidators();
      control?.setValue('');
      control?.updateValueAndValidity();
    });
    const active = this.agentValidators[value];
    if (active) {
      this.registerForm.get(active.field)?.setValidators(active.validators);
      this.registerForm.get(active.field)?.updateValueAndValidity();
    }
  }
}
